var coordinates = (function () {
  var selectedRoadCoordinates;

    function _updateStartStop($startElement, $stopElement, startPosition, stopPosition) {
        if ($startElement.val() && $stopElement.val()) {
            var startKm = parseFloat($startElement.val());
            var stopKm = parseFloat($stopElement.val());
            if (stopKm > stopPosition) {
                $stopElement.val(stopPosition.toFixed(3));
            }
            else if (stopKm < startPosition) {
                $stopElement.val(startPosition.toFixed(3));
            }
            if (startKm > stopPosition) {
                $startElement.val(stopPosition.toFixed(3));
            }
            else if (startKm < startPosition) {
                $startElement.val(startPosition.toFixed(3));
            }
        }
    }

    function _updateLocation($element, startPosition, stopPosition) {
        if ($element.val()) {
            var location = parseFloat($element.val());
            if (location > stopPosition) {
                $element.val(stopPosition.toFixed(3));
            }
            else if (location < startPosition) {
                $element.val(startPosition.toFixed(3));
            }
        }
    }

    function updateCoordinates(option) {
        var minRoadKm = null;
        if (option.hasOwnProperty('roadStartKm'))
            minRoadKm = option.roadStartKm;
        else
            minRoadKm = getRoadStartKm();
        if (option.isPoint) {
            if (selectedRoadCoordinates.length &&
                selectedRoadCoordinates[selectedRoadCoordinates.length - 1].length > 1) {
                var lastSection = selectedRoadCoordinates[selectedRoadCoordinates.length - 1];
                var maxRoadKm = MapHelper.findPosition(lastSection[lastSection.length - 1],
                        selectedRoadCoordinates, MapHelper.getZoom(option.map).coefficient).distance / 1000 + minRoadKm;
                _updateLocation($('#Location'), minRoadKm, maxRoadKm);
                if (!option.ignoreCoordinate) {
                    var searchRes =
                        MapHelper.findPositionByDistance($('#Location').val() * 1000, selectedRoadCoordinates);
                    if (searchRes.point != null) {
                        $('#Lat').val(searchRes.point.lat);
                        $('#Lng').val(searchRes.point.lng);
                        sessionStorage.Lat = searchRes.point.lat;
                        sessionStorage.Lng = searchRes.point.lng;
                    }
                }
            }
            return 0;
    } else {
      var returnedCoord = 0;

        if (!selectedRoadCoordinates.length || selectedRoadCoordinates[selectedRoadCoordinates.length - 1].length < 2) {
            $('#CoordinatesCsv').val(null);
            $('#SelectedLocalityWithRoad_CoordinatesCsv').val(null);
            $('#SelectedLongObjectWithRoad_CoordinatesCsv').val(null);

        } else {
            
            // Находим общую длину дороги
            var lastSection = selectedRoadCoordinates[selectedRoadCoordinates.length - 1];
            var maxRoadKm = MapHelper.findPosition(lastSection[lastSection.length - 1],
                    selectedRoadCoordinates,
                    MapHelper.getZoom(option.map).coefficient).distance /
                1000 + minRoadKm;

            _updateStartStop($('#StartKm'), $('#StopKm'), minRoadKm, maxRoadKm);
            _updateStartStop($('#SelectedLocalityWithRoad_StartKm'), $('#SelectedLocalityWithRoad_StopKm'), minRoadKm, maxRoadKm);
            _updateStartStop($('#SelectedLongObjectWithRoad_StartKm'), $('#SelectedLongObjectWithRoad_StopKm'), minRoadKm, maxRoadKm);
        }
        return returnedCoord;
    }
  }

    function updateFreeLocation() {
        var lat = parseFloat($('#Lat').val());
        var lng = parseFloat($('#Lng').val());
        if (lat || lat === 0) {
            if (lat > AppConfig.defaultMapBounds[0][0])
                lat = AppConfig.defaultMapBounds[0][0];
            if (lat < AppConfig.defaultMapBounds[1][0])
                lat = AppConfig.defaultMapBounds[1][0];
            $('#Lat').val(lat);
        }
        if (lng || lng === 0) {
            if (lng > AppConfig.defaultMapBounds[1][1])
                lng = AppConfig.defaultMapBounds[1][1];
            if (lng < AppConfig.defaultMapBounds[0][1])
                lng = AppConfig.defaultMapBounds[0][1];
            $('#Lng').val(lng);
        }
    }

  function reloadRoadCoordinates(roadId) {

    if (roadId === undefined) {
      roadId = $('#RoadId,#Road_Id').val();
    }

    return $.ajax({
        url: Url.action('roads/{0}/coordinates', roadId),
        contentType: 'application/json; charset=utf-8',
        type: 'GET',
        dataType: 'json'
      })
      .success(function(result) {
        selectedRoadCoordinates = MapHelper.convertToLatLng(result);
      })
      .error(function(xhr, status, statusCode) {
        selectedRoadCoordinates = [[]];
      });
    }

    function getRoadStartKm(roadId) {

        if (roadId === undefined) {
            roadId = parseInt($('#RoadId,#Road_Id,#SelectedLongObjectWithRoad_RoadId,#SelectedLocalityWithRoad_RoadId').val());
        }
        if (!roadId || !roads)
            return 0;

        var road = roads.filter(function(r) {
            return r.Id === roadId;
        });
        if (road.length) {
            return road[0].StartKm;
        }
        return 0;
    }

  return {
    updateCoordinates: updateCoordinates,
    updateFreeLocation: updateFreeLocation,
    reloadRoadCoordinates: reloadRoadCoordinates,
    getRoadStartKm: getRoadStartKm
  };
}());
